import { render, staticRenderFns } from "./ShallowWaterWarning.vue?vue&type=template&id=245f1816&scoped=true"
import script from "./ShallowWaterWarning.vue?vue&type=script&lang=js"
export * from "./ShallowWaterWarning.vue?vue&type=script&lang=js"
import style0 from "./ShallowWaterWarning.vue?vue&type=style&index=0&id=245f1816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f1816",
  null
  
)

export default component.exports